"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const logos = [{
  name: "Global Executive Forum",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_executive_forum.png"
}, {
  name: "Leadership Institute",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_leadership_inst.png"
}, {
  name: "Strategic Network",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_strategic_net.png"
}, {
  name: "Corporate Excellence",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_corp_excellence.png"
}, {
  name: "Future Leaders",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663430/img/partner_future_leaders.png"
}];
export default function MediaMentions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}